module.exports = __webpack_public_path__ + "static/QT-44316f9d5ba67c717a99db619b732288.jpg";